var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 3.99999H17.3334V5.66666H15.6667V16.5C15.6667 16.721 15.5789 16.933 15.4226 17.0892C15.2663 17.2455 15.0544 17.3333 14.8334 17.3333H3.16669C2.94567 17.3333 2.73371 17.2455 2.57743 17.0892C2.42115 16.933 2.33335 16.721 2.33335 16.5V5.66666H0.666687V3.99999H4.83335V1.49999C4.83335 1.27898 4.92115 1.06701 5.07743 0.910734C5.23371 0.754454 5.44567 0.666656 5.66669 0.666656H12.3334C12.5544 0.666656 12.7663 0.754454 12.9226 0.910734C13.0789 1.06701 13.1667 1.27898 13.1667 1.49999V3.99999ZM14 5.66666H4.00002V15.6667H14V5.66666ZM6.50002 2.33332V3.99999H11.5V2.33332H6.50002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.3bb4d7d36566260013c3dea686a7ebc2.svg";
export { ForwardRef as ReactComponent };